<aside
    class="modal-container"
    [ngClass]="{
        'translate-y-0 scale-100': (active | async),
        'translate-y-2/3 scale-0': !(active | async),
        'transition duration-200': animate,
        'p-0!': (isModalFullscreen | async),
    }">
    <div class="modal-backdrop" (click)="hide()"></div>
    <div
        class="relative z-50 flex max-h-full w-full flex-col overflow-hidden bg-white shadow-md md:max-h-[90vh] md:w-max"
        [ngClass]="modalContainerCombinedClass | async">
        @if ((showBackButton | async) || (canHide | async)) {
            <div
                class="flex flex-row justify-between px-4 pt-4 md:px-6 md:pt-6"
                [ngClass]="navigationStyles | async">
                <div>
                    @if (showBackButton | async) {
                        <div class="cursor-pointer pb-4">
                            <svg
                                xmlns="http://www.w3.org/2000/svg"
                                viewBox="0 0 22 20"
                                class="inline h-8 w-8 fill-current p-1"
                                (click)="back()">
                                <path
                                    d="M20.3334 8.66668H4.52004L9.36004 2.85334C9.58636 2.58106 9.69524 2.23002 9.66273 1.87745C9.63023 1.52488 9.459 1.19966 9.18671 0.973345C8.91442 0.747027 8.56338 0.638144 8.21081 0.670651C7.85824 0.703157 7.53302 0.874389 7.30671 1.14668L0.640041 9.14668C0.595188 9.21031 0.55508 9.27716 0.52004 9.34668C0.52004 9.41335 0.520041 9.45335 0.426708 9.52001C0.366272 9.67289 0.334629 9.83563 0.333374 10C0.334629 10.1644 0.366272 10.3271 0.426708 10.48C0.426708 10.5467 0.426707 10.5867 0.52004 10.6533C0.55508 10.7229 0.595188 10.7897 0.640041 10.8533L7.30671 18.8533C7.43207 19.0039 7.58906 19.1249 7.7665 19.2079C7.94395 19.2908 8.13749 19.3337 8.33337 19.3333C8.64491 19.334 8.94683 19.2255 9.18671 19.0267C9.32172 18.9147 9.43332 18.7773 9.51512 18.6221C9.59693 18.467 9.64732 18.2973 9.66342 18.1226C9.67952 17.948 9.66101 17.7719 9.60895 17.6044C9.5569 17.437 9.47231 17.2814 9.36004 17.1467L4.52004 11.3333H20.3334C20.687 11.3333 21.0261 11.1929 21.2762 10.9428C21.5262 10.6928 21.6667 10.3536 21.6667 10C21.6667 9.64639 21.5262 9.30725 21.2762 9.0572C21.0261 8.80715 20.687 8.66668 20.3334 8.66668Z" />
                            </svg>
                        </div>
                    }
                </div>
                <div class="cursor-pointer pb-4 text-right">
                    @if (canHide | async) {
                        <svg
                            xmlns="http://www.w3.org/2000/svg"
                            viewBox="0 0 492 492"
                            class="inline h-8 w-8 fill-current p-2"
                            (click)="hide()">
                            <path
                                d="M300 246L484 62a27 27 0 000-38L468 8a27 27 0 00-38 0L246 192 62 8a27 27 0 00-38 0L8 24a27 27 0 000 38l184 184L8 430a27 27 0 000 38l16 16a27 27 0 0038 0l184-184 184 184a27 27 0 0038 0l16-16a27 27 0 000-38L300 246z" />
                        </svg>
                    }
                </div>
            </div>
        }
        <div
            class="flex flex-col overflow-hidden"
            [ngClass]="instanceStyles | async">
            <div class="inline-block overflow-x-hidden overflow-y-auto">
                <ng-template appModal></ng-template>
            </div>
        </div>
    </div>
</aside>
